import React from "react";
import { MessageCircle } from "lucide-react";
import { useSiteSettings } from "../context/SiteSettingsContext";
import { useLang } from "../context/LanguageContext";
import { track } from "../lib/analytics";

export default function FloatingWhatsApp({ message }) {
  const { settings } = useSiteSettings() || {};
  const { lang, t, tBrand, isRTL } = useLang();
  const phone = settings?.general?.whatsapp_number || "962799448817";
  const siteName = tBrand(settings?.general?.site_name || "Shamstrade");
  const text =
    message ||
    (lang === "ar"
      ? `مرحباً ${siteName}، أرغب بالاستفسار عن المكيفات.`
      : `Hi ${siteName}! I'd like to ask about your air conditioners.`);
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
  return (
    <a
      href={url}
      onClick={() => track("whatsapp_click")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label={t("common.chatOnWhatsApp")}
      className={`fixed bottom-6 z-50 group ${isRTL ? "left-6" : "right-6"}`}
    >
      <span className="relative flex items-center gap-2.5 px-5 sm:pl-4 sm:pr-5 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-10px_rgba(37,211,102,0.6)] hover:bg-[#1ebe5b] transition-colors duration-300">
        {/* Ping confined to the icon area — see FloatingCall.jsx for the
            same fix. Prevents the wave-animation glitch where the ping
            stretched across the full pill and clashed with hover transitions. */}
        <span className="relative flex items-center justify-center w-10 h-10">
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40 pointer-events-none" />
          <MessageCircle size={22} strokeWidth={2.5} className="relative" />
        </span>
        <span className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.18em]">
          <span className="sm:hidden">WhatsApp</span>
          <span className="hidden sm:inline">{t("common.chatOnWhatsApp")}</span>
        </span>
      </span>
    </a>
  );
}
